import { RootState } from '@redux/types';

export const songsMetadataSelector = (state: RootState) => state.songStorage.storeSongMetadata;
